import React, {Component} from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {TableComp} from 'sz-react-utils'
import moment from 'moment/moment'
import _ from 'lodash'

import {Button, Card, Col, DatePicker, Drawer, Form, notification, Row, Tooltip, Checkbox} from 'antd/lib/index'
import Request from '../../../../request'

import {connect} from 'react-redux'

import styles from './styles.less'
import {getUrlPushWrapper} from '../../../../routes'
import {hideLoader, showLoader} from '../../../../modules/actions'
import rightAuth from '../../../../components/_utils/userRights'
import Exception from '../../../../components/Exception'
import {Link} from 'react-router-dom'

import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'

let studentObj = {};
let userCheckBox = {}
let counsellingData = {}


@Form.create()
class invoices extends Component {
    state = {
        count: 0,
        allBranches: [],
        channelPartnerList: [],
        deskColor: null,
        invoiceGenerationStatusList: [
            'Pending',
            'Invoice Processed'
        ],
        leadSourceList: ['University', 'Channel Partner'],
        studentStatusList: ['Not Enrolled Yet', 'Ongoing', 'Max Commission Paid', 'Withdrawn - Bad Debts'],
        visible: false,
        date: moment().add(1, 'days').startOf('day')._d,
        allow: true,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},

    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showSMS: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({showSMS: false})
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked == true?item:false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showWhatsAppSms: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeWhatsSMS = () => {
        this.setState({showWhatsAppSms: false})
    }
    closeEmail = () => {
        this.setState({showEmail: false})
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showEmail: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] == undefined) {
          cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    apiRequest = (params, columns) => {
        return new Promise(async resolve => {

            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            params.date = this.state.date ? this.state.date : ''
            params.atLevel = ['Claim Desk']
            let data = await Request.generatedInvoicesList({
                ...params
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({count: data.data.length, allBranches: data.allBranches, userCheckBox: userCheckBox})

            resolve(data)
        })
    }

    loadChannelPartners = async () => {
        let {data: channelPartnerList} = await Request.getSimplePartners({
            results: 10000
        })
        this.setState({channelPartnerList})
    }

    loadUserRights = async () => {
        let {userRights} = await Request.loadUserRights()
        this.setState({claimDeskRights: userRights.ClaimDesk})
    }
    saveDate = async () => {
        let {invoiceId, inquiryId} = this.state
        const {dispatch, form} = this.props

        let newInvoiceDate = form.getFieldValue('date')

        dispatch(showLoader())

        let x = await Request.saveInvoiceDate({newInvoiceDate, invoiceId, inquiryId})

        dispatch(hideLoader())
        if (!x.error) {

            notification.success({
                message: x.msg

            })
            this.setState({visible: false})
            form.resetFields()
            this.table.current.reload()


        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }

    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadChannelPartners()
        this.loadUserRights()
    }

    renderStatus = (val) => {
        if (val === 'Ongoing') {
            return <div className={styles.Ongoing}>{val}</div>
        }
        if (val === 'Not Enrolled Yet') {
            return <div className={styles.notEnrolled}>{val}</div>
        }

        if (val === 'Max Commission Paid') {
            return <div className={styles.maxCommission}>{val}</div>
        }

        if (val === 'Withdrawn - Bad Debts') {
            return <div className={styles.withdrawn}>{val}</div>
        }

    }

    onChange = (date, dateString) => {
        this.setState({
                date: date && date._d
            }, () => {
                this.reload()
            }
        )
    }
    showDrawer = () => {
        this.setState({
            visible: true
        })
    }

    reload = () => {
        this.table.current.reload()
    }


    async componentDidMount() {
        if (rightAuth.checkRights('ClaimDesk.viewByBranch')) {
            this.setState({allow: false})
        }
    }

    render() {
        const {dispatch, form: {getFieldDecorator}} = this.props
        const {
            allBranches = [],
            deskColor,
            channelPartnerList,
            invoiceGenerationStatusList,
            leadSourceList,
            studentStatusList,
            claimDeskRights,
            allow
        } = this.state


        const columns = [
            
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name (Mobile/WAP/E mail)',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                width: 200,
                fixed: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <Tooltip title="Click To Edit Details">
                                <a className={styles.btn} target={'_blank'}
                                   href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{text}</a>
                            </Tooltip>
                            <div>{record.mobile}</div>

                            <div>
                                {record.watsupp && record.watsupp.length == 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                           style={{textDecoration: 'underline'}}
                                           href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}

                            </div>
                            <div>{record.emailId}</div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchDateName: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Course/University',
                key: 'selectedCourse',
                width: 250,
                dataIndex: 'visaDesk.selectedCourse',
                searchTextName: 'course/University',
                filterRegex: true,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text.courseName : ''}</div>
                        <div>{text ? text.universityInstitutionName : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Course Start Date',
                key: 'courseStartDate',
                width: 100,
                dataIndex: 'visaDesk.courseStartDate',
                searchDateName: 'courseStartDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'branchId',
                filters: allBranches,
                width: 80,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Student Status',
                key: 'studentStatus',
                width: 160,
                dataIndex: 'studentStatus',
                filters: studentStatusList && studentStatusList.map(x => ({value: x, text: x})),
                render: (text, record) => {
                    return this.renderStatus(text)
                }
            },
            {
                title: 'Term',
                width: 70,
                key: 'invoiceNo',
                dataIndex: 'generatedInvoices',
                searchTextName: 'invoiceNo',
                filterRegex: true,
                render: (text, record) => {
                    return (<div>{text ? text.invoiceNo : ''}</div>)
                }
            },
            {
                title: 'Invoice Date',
                width: 90,
                key: 'invoiceGenerationDate',
                dataIndex: 'generatedInvoices',
                render: (text, record) => {
                    return (<div>{text ? moment(text.invoiceGenerationDate).format('DD-MMM-YYYY') : ''}</div>)
                }
            },
            {
                title: 'Invoice Status',
                width: 100,
                key: 'invoiceGenerationStatus',
                dataIndex: 'generatedInvoices',
                filters: invoiceGenerationStatusList && invoiceGenerationStatusList.map(x => ({value: x, text: x})),
                render: (text, record) => {
                    return (<div>{text ? text.invoiceGenerationStatus : ''}</div>)
                }

            }]

        if (claimDeskRights && !claimDeskRights.viewByBranch) {

            let dataItem = {
                title: 'Invoicee',
                key: 'leadSource',
                dataIndex: 'leadSource',
                width: 180,
                filters: leadSourceList && leadSourceList.map(x => ({value: x, text: x})),
                render: (text, record) => {
                    let found
                    if (record.visaDesk.channelPartnerId != '') {
                        found = _.find(channelPartnerList, (item) => {
                            return item._id == record.visaDesk.channelPartnerId
                        })
                    }
                    return (<div>
                        <div>{text}</div>
                        <small style={{color: '#ffa500'}}>{found ? found.channelPartnerName : ''}</small>
                    </div>)
                }
            }
            let dataItem1 = {
                title: 'Action',
                key: 'opertaions',
                width: 80,
                fixed: true,
                render: (text, record) => {
                    return (
                        <div>
                            <React.Fragment>
                                <div className={styles.btnWrapper}>
                                    <span className={styles.userSelectCheckbox}>
                                      <Checkbox
                                          checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                          onChange={y => {
                                              this.selectUser(y, record._id)
                                          }}>
                                      </Checkbox>
                                    </span>
                                </div>
                            </React.Fragment>
                            {record && record.generatedInvoices && record.generatedInvoices.invoiceGenerationStatus == 'Pending' &&
                                <Button
                                    style={{
                                        backgroundColor: '#85CF4A',
                                        border: '1px solid #85CF4A',
                                        color: 'white'
                                    }}
                                    className={styles.btn}
                                    size={'small'}
                                    onClick={() => {
                                        dispatch(getUrlPushWrapper('desk.generateInvoice', {
                                            id: record._id,
                                            invoiceId: record && record.generatedInvoices && record.generatedInvoices._id
                                        }))
                                    }}
                                >Add Invoice</Button>
                            }
                            {record && record.generatedInvoices && record.generatedInvoices.invoiceGenerationDate &&
                                <Tooltip title={'Edit Invoice Date'}>
                                    <Button
                                        style={{marginTop: '5px'}}
                                        size={'small'}
                                        icon="edit"
                                        shape="circle"
                                        onClick={() => {
                                            this.setState({
                                                inquiryId: record._id,
                                                invoiceId: record && record.generatedInvoices && record.generatedInvoices._id,
                                                invoiceOldDate: record && record.generatedInvoices && record.generatedInvoices.invoiceGenerationDate
                                            }, () => {
                                                this.props.form.setFieldsValue({date: moment(this.state.invoiceOldDate)})
                                            })
                                            this.showDrawer()
                                        }}
                                    /></Tooltip>
                            }


                        </div>)
                }
            }
            columns.splice(0, 0, dataItem1)
            columns.splice(7, 0, dataItem)
        }

        return (
            !allow ? <Exception
                    type="404"
                    desc={'You Seems lost !!'}
                    linkElement={Link}
                    redirect={'/dashboard'}
                    backText={'Go To Homepage?'}
                /> :
                <PageHeaderWrapper deskColor={deskColor} title={` Invoices To Be Generated : ${this.state.count} `}>
                    <Card style={{marginBottom: 10}}>
                        <div style={{display: 'flex'}}>
                            <h4 style={{paddingTop: 8, paddingRight: 8}}>{`Invoice Date <=`}</h4>
                            <DatePicker
                                defaultValue={moment().add(1, 'days').startOf('day')}
                                onChange={this.onChange}/>
                        </div>
                    </Card>
                    {this.state.showWhatsAppSms ? (
                        <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS}/>
                    ) : null}

                    {this.state.showSMS ? (
                        <SMS counsellingData={counsellingData} onClose={this.closeSMS}/>
                    ) : null}

                    {this.state.showEmail ? (
                        <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail}/>
                    ) : null}
                    <Card style={{marginBottom: 10}}>
                      <div className={styles.filterBlock}>
                        <div className={styles.myBtnGroup}>
                          <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                            <Button
                                className={styles.btn}
                                type="primary"
                                onClick={() => this.showEmail()}>Send E-mail
                            </Button>
                            <Button
                                type="primary"
                                className={styles.btn}
                                onClick={() => this.showSMS()}>Send SMS
                            </Button>
                            <Button
                                type="primary"
                                className={styles.btn}
                                onClick={() => this.showWhatsAppSms()}>Whatsapp
                            </Button>
                            <Button
                                className={styles.btn}
                                onClick={() => this.selectAllUserFxn()}>Select Visible
                            </Button>
                            <Button
                                className={styles.btn}
                                onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card>
                    <Card bordered={true}>
                        <TableComp
                            rowKey={(item, x) => {
                                return x
                            }}
                            columns={columns}
                            ref={this.table}
                            id={'claimDesk'}
                            apiRequest={this.apiRequest}
                            extraProps={{scroll: {x: claimDeskRights && !claimDeskRights.viewByBranch ? 1545 : 1200}}}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 20,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    <Drawer
                        title=""
                        forceRender={true}
                        placement="right"
                        closable={true}
                        onClose={() => {
                            this.setState({
                                visible: false
                            })
                        }}
                        visible={this.state.visible}
                        width={400}>
                        <div style={{marginLeft: 20, marginTop: 20}}>
                            <Form labelCol={{span: 8}}
                                  wrapperCol={{span: 14}}
                                  layout="horizontal">
                                <Row><Col>
                                    <Form.Item label="Choose Date:">
                                        {getFieldDecorator('date')
                                        (<DatePicker format={'DD-MM-YYYY'}
                                                     required={true}
                                                     onChange={(v) => {
                                                     }}
                                        />)}
                                    </Form.Item>
                                </Col></Row>
                                <Form.Item>
                                    <Button type={'primary'}
                                            style={{marginLeft: '100px', marginTop: '30px'}}
                                            loading={this.props.loading}
                                            onClick={() => {
                                                this.saveDate()
                                            }}>Save</Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Drawer>
                </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories,
    loading: global.buttonLoading

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(invoices)
